import React, { Suspense } from 'react'

import { Await } from 'react-router-dom'

import ByScorePieChart from '@components/myScores/ChartCard/ByScorePieChart'
import ByTimeframeChart from '@components/myScores/ChartCard/ByTimeframeChart'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import NFIcon from '@components/shared/NFIcon'
import { ByScoreResponse, ByTimeframeResponse } from '@pages/home/loaders/dashboard.loader'

interface Props {
  data: Promise<ByScoreResponse | ByTimeframeResponse>
  title: string
  icon: string
  timeIncrement?: number
}

const index: React.FC<Props> = ({ data, title, icon, timeIncrement }) => {
  return (
    <div className="bg-white dark:bg-black-bg2 border border-gray-border dark:border-gray-border-dm rounded flex-1 min-w-0 inline-flex mb-0 max-w-[600px] w-full min-h-[250px] flex flex-col p-2.5 relative">
      <h1 className="text-xl font-semibold flex flex-row items-center gap-2 h-12">
        <NFIcon icon={icon} />
        {title}
      </h1>
      <Suspense fallback={<LoadingSpinner />}>
        <Await resolve={data}>
          {(resp: ByScoreResponse | ByTimeframeResponse) => {
            if ((resp as ByScoreResponse).data_points.top) {
              return <ByScorePieChart resp={resp as ByScoreResponse} />
            }
            return (
              <ByTimeframeChart
                resp={resp as ByTimeframeResponse}
                timeIncrement={timeIncrement ?? 0}
              />
            )
          }}
        </Await>
      </Suspense>
    </div>
  )
}

export default index
